<script lang="ts" setup>
interface Props {
  title?: string
  src?: string
  body?: string
  uid?: string
  flip?: boolean
  buttons?: Button[]
  titleClass?: string
  pretitle?: string
  theme?: Theme
  index: number
}
const { index, theme = 'light' } = defineProps<Props>()
</script>

<template>
  <div
    class="px-3 md:px-6 overflow-hidden"
    :class="'bg-theme-' + theme"
  >
    <section
      class="flex flex-col lg:flex-row flex-wrap p-6 mx-auto max-w-screen-2xl py-10 lg:py-16 gap-24"
      :class="`gsap-container-${index}`"
    >
      <div
        class=" order-2 w-full lg:w-1/2 flex flex-col justify-center "
        :class="[flip ? '' : 'lg:order-1']"
      >
        <section
          class="flex flex-col body py-6 lg:py-32 "
          :class="`gsap-textbox-${index}`"
        >
          <p
            v-if="pretitle"
            class="pretitle"
          >
            {{ pretitle }}
          </p>
          <h3
            class="pb-6 text-2xl md:text-4xl lg:text-5xl header"
            :class="titleClass"
          >
            {{ title }}
          </h3>
          <Markdown
            v-if="body"
            :md="body"
          >
            {{ body }}
          </Markdown>
          <div class="flex flex-wrap gap-3">
            <ButtonGeneral
              v-for="(button, index) in buttons"
              :key="index"
              v-bind="button"
              class="self-start mt-6 md:mt-6 lg:mt-8"
              :theme="theme"
            />
          </div>
          <slot />
        </section>
      </div>
      <div
        class="flex-1 order-1 overflow-hidden  h-64 lg:h-auto w-full rounded-4xl"
        :class="[{ 'lg:order-2': !flip }, `gsap-image-${index}`]"
      >
        <GeneralImage
          :src="src"
          :alt="title"
          class="object-cover lg:w-full lg:h-full"
        />
      </div>
    </section>
  </div>
</template>

<style lang="css" scoped>
</style>
